import * as React from "react"
const SvgTemplate = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m7.425 9.76 3.725-6.074a.9.9 0 0 1 .375-.363 1.05 1.05 0 0 1 .95 0q.225.113.375.363l3.725 6.075q.15.249.15.525 0 .275-.125.5a.97.97 0 0 1-.875.5h-7.45a.97.97 0 0 1-.875-.5 1 1 0 0 1-.125-.5q0-.276.15-.525ZM17.5 22.287q-1.875 0-3.188-1.313Q13 19.662 13 17.787t1.313-3.188q1.312-1.312 3.187-1.312t3.188 1.312C22.001 15.911 22 16.536 22 17.786q0 1.875-1.313 3.187c-1.313 1.312-1.937 1.313-3.187 1.313ZM3 20.786v-6q0-.426.288-.713A.97.97 0 0 1 4 13.786h6q.424 0 .713.287.287.288.287.713v6a.97.97 0 0 1-.287.712.97.97 0 0 1-.713.288H4a.97.97 0 0 1-.712-.288.97.97 0 0 1-.288-.712m14.5-.5q1.05 0 1.775-.725.725-.726.725-1.775c0-1.049-.242-1.292-.725-1.775q-.725-.725-1.775-.725c-1.05 0-1.292.241-1.775.725Q15 16.736 15 17.786c0 1.05.242 1.291.725 1.775q.725.725 1.775.725m-12.5-.5h4v-4H5zm5.05-10.5h3.9L12 6.136z" />
  </svg>
)
export default SvgTemplate
